import styled from 'styled-components';

import { ReactComponent as BroadcastIcon } from '../../../../../assets/icons/broadcast-icon.svg';
import colors from '../../../../../styles/colors';

const StyledBroadcastIcon = styled(BroadcastIcon)`
  > path {
    stroke: ${colors.base.secondary2};
  }
`;

const StyledContainer = styled.div`
  align-self: center;
`;

export {
  StyledContainer,
  StyledBroadcastIcon,
};
